<template>
  <div class="colorTable" id="table-print" v-cloak>
    <template v-for="(item, ind) in data">
      <p :key="ind">{{ emitLoadCalc(ind) }}</p>
      <!-- <pre>{{ item }}</pre> -->
      <template v-for="(t, i) in item.tournaments">
        <div
          :key="`t-${t.id}-${item.id}`"
          style="background: rgba(0, 0, 0, 0.25)"
          class="subtitle-2 text--secondary"
          :class="[$vuetify.breakpoint.smAndDown ? 'px-2' : 'px-4']"
        >
          <!-- <pre>{{ t }}</pre> -->
          <div class="row no-gutters" :key="i">
            <div
              :class="[
                $route.query.event ? 'col-md-6 col-lg-6' : 'col-md-3 col-lg-4',
              ]"
              class="d-flex align-center overflow-hidden col-sm-6 col"
            >
              <div class="subtitle-2 text--secondary text-truncate">
                <img
                  class="flag mr-3 d-print-none"
                  width="24"
                  :src="flag(item.flag, t.flag)"
                  :alt="item.name || $route.query.category"
                />
                <span v-show="$vuetify.breakpoint.smAndUp"
                  >{{ item.name || $route.query.category }} &nbsp;›&nbsp;</span
                >
                {{ t.name }}
              </div>
            </div>
            <div
              :class="[
                $route.query.event ? 'col-md-6 col-lg-5' : 'col-md-8 col-lg-7',
              ]"
              class="d-flex align-center text-center col-sm-6 col d-print-none"
              style="font-size: 11px"
            >
              <div class="row no-gutters justify-end">
                <div
                  class="col"
                  v-for="(market, index) in idMarkets"
                  :key="`${market.legends}-${index}`"
                  :class="[`col-${12 / idMarkets.length}`]"
                >
                  <div
                    class="row no-gutters flex-nowrap justify-center"
                    :class="[$vuetify.breakpoint.xsOnly ? 'pl-2' : 'pl-2']"
                  >
                    <template v-for="(legend, index) in market.legends">
                      <div
                        :key="`legend-${index}`"
                        class="
                          px-1
                          transparent
                          d-flex
                          justify-center
                          align-center
                        "
                        :style="{
                          'min-width': $vuetify.breakpoint.xsOnly
                            ? '50px'
                            : '56px',
                          'min-height': $vuetify.breakpoint.xsOnly
                            ? '50px'
                            : '50px',
                          margin: $vuetify.breakpoint.xsOnly
                            ? '0 0 0 4px !important'
                            : '0 4px 0 4px !important',
                        }"
                      >
                        {{ legend }}
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-if="$vuetify.breakpoint.smAndDown || !$route.query.event" class="d-flex align-center justify-center text--secondary col-md-1 col">
              <div></div>
            </div>-->
          </div>
        </div>

        <div :key="`list-${i}-${item.id}`" class="py-0">
          <template v-for="(e, n) in t.events">
            <div
              :key="`event-${n}`"
              class="c-custom-h position-relative"
              :class="[
                $vuetify.breakpoint.smAndDown ? 'px-2' : 'px-4',
                $route.params.event == e.id ? 'selected-open-event' : '',
              ]"
            >
              <div
                class="row no-gutters event-row flex-nowrap"
                :id="e.id"
                :ref="e.id"
              >
                <div
                  :class="[
                    $route.query.event
                      ? 'col-md-6 col-lg-6'
                      : 'col-md-3 col-lg-4',
                  ]"
                  class="d-flex align-center subtitle-2 col-sm-6 col c-p-col-6"
                >
                  <div class="row no-gutters" style="flex-wrap: nowrap">
                    <div
                      class="
                        d-flex
                        align-center
                        justify-center
                        py-0
                        col col-md-1 col-1
                        d-print-none
                      "
                      v-if="$vuetify.breakpoint.mdAndUp"
                    >
                      <div
                        class="
                          text--secondary text-center
                          d-flex
                          justify-center
                        "
                        style="font-size: 10px; line-height: 16px"
                      >
                        <div v-if="!(type === 'live')">
                          <div>{{ e.scheduled | formatDate }}</div>
                          <div>{{ e.scheduled | formatHour }}</div>
                        </div>
                        <div v-if="type == 'live'">
                          <v-chip
                            x-small
                            outlined
                            class="my-1 pa-2 live-ani"
                            color="primary"
                            text-color="primary"
                            >live</v-chip
                          >
                          {{ e.scheduled | formatHour }}
                        </div>
                      </div>
                      <hr
                        class="
                          v-divider v-divider--inset v-divider--vertical
                          theme--dark
                          pl-3
                        "
                        v-show="$vuetify.breakpoint.xlOnly"
                      />
                    </div>

                    <div
                      class="
                        py-2
                        flex-grow-0 flex-shrink-1
                        col col-md-9 col-12
                        compt
                      "
                      :class="[$vuetify.breakpoint.smAndDown ? 'pl-0' : 'pl-3']"
                    >
                      <div
                        class="cursor-pointer pl-1"
                        @click="
                          routerPush(
                            item.id,
                            t.id,
                            e.id,
                            item.name,
                            t.name,
                            e.description,
                            item.flag ? item.flag : t.flag
                          )
                        "
                      >
                        <div
                          class="text-truncate d-block nameComp pr-2"
                          :style="{
                            'max-width': $vuetify.breakpoint.xsOnly
                              ? '150px'
                              : '250px',
                          }"
                        >
                          <TeamLogo
                            :id_sport="idSport"
                            :id_team="e.id_team_1"
                            class="mr-1"
                          />
                          {{ e.description.split(" X ")[0] }}
                        </div>
                        <div
                          class="text-truncate d-block nameComp pr-2"
                          :style="{
                            'max-width': $vuetify.breakpoint.xsOnly
                              ? '150px'
                              : '250px',
                          }"
                        >
                          <TeamLogo
                            :id_sport="idSport"
                            :id_team="e.id_team_2"
                            class="mr-1"
                          />
                          {{ e.description.split(" X ")[1] }}
                        </div>

                        <div
                          class="d-print-block d-none"
                          style="font-size: 10px; line-height: 16px"
                        >
                          <div>{{ e.scheduled | formatDate }}</div>
                        </div>

                        <div
                          v-if="$vuetify.breakpoint.smAndDown"
                          class="text--secondary d-print-none"
                          style="font-size: 10px; line-height: 16px"
                        >
                          <span v-if="type == 'live'">
                            <v-chip
                              x-small
                              outlined
                              class="mr-1 my-1 px-2 live-ani"
                              color="primary"
                              text-color="primary"
                              >Live</v-chip
                            >
                          </span>
                          <span v-else>
                            <v-chip
                              v-if="e.liveodds > 0"
                              x-small
                              outlined
                              class="mr-1 my-1 px-2"
                              >Live</v-chip
                            >
                            {{ e.scheduled | formatDate }}
                          </span>
                          {{ e.scheduled | formatHour }} &nbsp;&nbsp;&nbsp;
                          <span class="primary--text">{{
                            e.count_odds
                              | formatPlus($vuetify.breakpoint.smAndDown)
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- próximos em live -->
                    <div
                      class="
                        pr-2
                        col col-1 col-md-2
                        d-flex
                        align-center
                        justify-center
                        d-print-none
                      "
                      v-if="
                        !(type === 'live') &&
                          e.liveodds > 0 &&
                          $vuetify.breakpoint.mdAndUp == true
                      "
                    >
                      <v-chip
                        x-small
                        outlined
                        :class="[
                          $vuetify.breakpoint.xlOnly ? 'pa-2' : 'px-1 py-2',
                        ]"
                        >Live</v-chip
                      >
                    </div>

                    <!-- score -->
                    <div
                      class="accent--text py-2 col col-1 col-md-2 d-print-none"
                      :class="$vuetify.breakpoint.smAndDown ? 'mr-1' : ''"
                      v-if="type == 'live'"
                    >
                      <div class="text-center">
                        {{ e.score != null ? e.score.split(" - ")[0] : "" }}
                      </div>
                      <div class="text-center">
                        {{ e.score != null ? e.score.split(" - ")[1] : "" }}
                      </div>
                    </div>
                  </div>
                  <hr
                    class="
                      v-divider v-divider--inset v-divider--vertical
                      theme--dark
                      d-print-none
                    "
                  />
                </div>

                <div
                  :class="[
                    $route.query.event
                      ? 'col-md-6 col-lg-5'
                      : 'col-md-8 col-lg-7',
                  ]"
                  class="d-flex align-center text-center col-sm-6 col c-p-col-6"
                >
                  <div class="row no-gutters justify-end">
                    <div
                      v-for="(market, i) in idMarkets"
                      :key="`${market.name_market}-${i}`"
                      :class="[
                        `col col-${12 / idMarkets.length}`,
                        i < 1 ? 'd-print-block c-p-col-12' : 'd-print-none',
                      ]"
                    >
                      <div
                        class="row no-gutters flex-nowrap justify-center"
                        :class="[$vuetify.breakpoint.xsOnly ? 'pl-2' : 'pl-2']"
                      >
                        <template v-for="o in e.odds">
                          <ListOdds
                            :key="o.id_odd"
                            v-if="market.id_market === o.id_market"
                            :event="e"
                            :odd="o"
                            :minOdd="$store.state.operators.odd_min"
                          />
                          <!-- v-on:putCar="selectOdd" -->
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-md-1 col col-1 d-print-none"
                  :class="{
                    none:
                      $vuetify.breakpoint.smAndDown ||
                      ($vuetify.breakpoint.mdAndUp && $route.query.event),
                    'd-flex':
                      ($vuetify.breakpoint.lgAndUp && !$route.query.event) ||
                      ($vuetify.breakpoint.xlOnly && $route.query.event),
                  }"
                >
                  <div class="d-flex fill-height flex-grow-1">
                    <hr
                      class="
                        v-divider v-divider--inset v-divider--vertical
                        theme--dark
                        pl-2
                      "
                    />
                    <div class="d-flex align-center justify-end flex-grow-1">
                      <button
                        style="
                          font-size: 11px;
                          background: rgba(255, 255, 255, 0.1);
                        "
                        @click="
                          routerPush(
                            item.id,
                            t.id,
                            e.id,
                            item.name,
                            t.name,
                            e.description,
                            item.flag ? item.flag : t.flag
                          )
                        "
                        class="
                          mx-2
                          v-btn v-btn--contained v-btn--fab
                          text-capitalize
                          v-btn--round
                          outlined
                          text-center
                          v-size--small
                          elevation-0
                        "
                      >
                        {{
                          e.count_odds
                            | formatPlus($vuetify.breakpoint.smAndDown)
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr
              class="v-divider theme--dark"
              v-show="n + 1 < t.events.length"
              :key="`width-${n}`"
            />
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import ListOdds from "./table-components/list-odds";
import { mapState } from "vuex";
import TeamLogo from "@/components/team-logo";

export default {
  name: "table-primary",
  props: ["type", "data", "print"],
  components: {
    ListOdds,
    TeamLogo,
  },
  data: function() {
    return {};
  },

  mounted() {},

  computed: mapState({
    // recupera o nome do esporte na query
    sportName: function() {
      let sportName;
      if (this.type === "nextEvents") {
        sportName = this.$route.query.sport;
      }
      if (this.type === "live") {
        if (this.$route.params.event) {
          sportName = this.$route.query.sport;
        } else {
          sportName = this.$route.query.live;
        }
      }
      return sportName;
    },

    coupons: function() {
      return this.$store.state.coupons;
    },

    // recupera um array de id markets para a composição de colunas, legendas e odds da tabela;
    idMarkets: function() {
      let sport = this.idSport;
      let breakpoint = this.$vuetify.breakpoint.name;
      let event = this.$route.params.event;
      return this.$store.getters.getIdMarkets(
        sport,
        breakpoint,
        event,
        this.type
      );
    },

    // recupera o id do sport
    idSport: function() {
      return this.$store.getters.getIdSportByName(this.sportName);
    },
  }),

  watch: {},

  methods: {
    emitLoadCalc(ind) {
      // console.log(ind);
      // this.$emit("load", ind + 1);
    },

    flag: function(a, b) {
      let flag;
      if (a) flag = a;
      if (b) flag = b;
      return `https://dozr8la71aog.cloudfront.net/flags/1x1/${flag}.svg`;
    },

    routerPush: function(
      categoryId,
      tournamentId,
      eventId,
      categoryName,
      tournamentName,
      eventDescription,
      categoryFlag
    ) {
      let nameRoute;
      if (this.type === "live") {
        nameRoute = "eventsLive";
      } else if (
        this.$route.name === "Sports" ||
        this.$route.name === "tournament" ||
        this.$route.name === "eventsTournament"
      ) {
        nameRoute = "eventsTournament";
      } else if (
        this.$route.name === "category" ||
        this.$route.name === "eventsCategory"
      ) {
        nameRoute = "eventsCategory";
      } else if (
        this.$route.name === "special" ||
        this.$route.name === "eventsSpecial"
      ) {
        nameRoute = "eventsSpecial";
      }

      this.$router.push({
        name: nameRoute,
        params: {
          sport: this.idSport,
          category: categoryId ? categoryId : this.$route.params.category,
          tournament: tournamentId
            ? tournamentId
            : this.$route.params.tournament,
          event: eventId,
        },
        query: {
          sport: this.sportName,
          category: categoryName ? categoryName : this.$route.query.category,
          tournament: tournamentName
            ? tournamentName
            : this.$route.query.tournament,
          event: eventDescription,
          liveEvent:
            this.type == "live" || this.$route.name === "live" ? true : false,
          mobile: this.$vuetify.breakpoint.smAndDown,
          flag: categoryFlag,
        },
      });
    },
  },
  filters: {
    formatPlus: (val, mobile) => {
      if (val != undefined && mobile) return `+${val} odds`;
      if (val != undefined) return `+${val}`;
      return "+";
    },
    formatDate: (val) => {
      var dateEvent = new Date(val.replace(" ", "T"))
        .toLocaleDateString()
        .slice(0, -5);
      var today = new Date().toLocaleDateString().slice(0, -5);
      if (dateEvent == today) return "HOJE";
      return dateEvent;
    },
    formatHour: (val) => {
      // Tratamento do Horário quando retornado do websocket ("2020-08-05T19:00:00.000Z")
      // retirar o "Z" do final.
      if (val.lastIndexOf("Z") != -1) {
        return new Date(`${val.slice(0, -5)}-03:00`)
          .toLocaleTimeString()
          .slice(0, -3);
      }
      return new Date(val.replace(" ", "T")).toLocaleTimeString().slice(0, -3);
    },
  },
};
</script>
<style lang="sass">
.flag
  display: inline-block
  vertical-align: baseline
  margin-bottom: -7px
  border-radius: 20px
  border: 2px solid rgba(255, 255, 255, .1)

.c-mobile-table
  .v-toolbar__content, .v-toolbar__extension
    padding: 4px 8px

.live-ani
  animation: liveAni
  animation-duration: 0.5s
  animation-iteration-count: infinite
  animation-direction: alternate
  animation-fill-mode: forwards
  animation-timing-function: ease-in-out
@keyframes liveAni
  0%
    opacity: 1
  100%
    opacity: 0.6
.event-row
  .d-flex
    z-index: 0
</style>

<style lang="css">
[v-cloak] > * {
  display: none;
}
[v-cloak]::before {
  content: "loading…";
}
</style>
